import {BaseModel} from "sjs-base-model";

export default class UserImportResponse extends BaseModel {
    public failedUsers: Map<string, string[]> = new Map<string, string[]>();
    public failedEntitlements: Map<string, string[]> = new Map<string, string[]>();
    public success: string = '';
    public error: { key: string; message: string; } = {
      key: '',
      message: ''
    };

    constructor(data: Partial<UserImportResponse>) {
        super();
        this.update(data);
      }
}